<template>
  <div class="timedatapage" ref="hoursdata" :style="{ height: minuteH + 'px' }">
    <!-- 实时在线 -->
    <div class="realtopbox">
      <div class="realtop">
        <div class="realtext">实时在线</div>
        <div class="timesline">
          <Icon class="iconclock" type="md-time" />
          监测时间：{{ onlyTime || '离线' }}
        </div>
      </div>
      <div class="realbottom" v-if="realTimeList && realTimeList.length">
        <div class="itemoptbox" v-for="(item, index) in realTimeList" :key="index">
          <div class="itemtitle">
            <div class="devicon iconcolor1">
              <i :class="item.icon"></i>
            </div>
            <div class="devtext">{{ item.cn_name }}</div>
          </div>
          <!-- 正常 normalcolor  异常 warningcolor -->
          <div class="itemline" v-if="item.zx_total">
            <div class="linetit">累计</div>
            <div class="linedata">{{ item.zx_total || '-' }}{{ item.unit }}</div>
          </div>
          <!-- 0 正常  1 过低  2 过高 -->
          <div class="itemline">
            <div class="linetit">平均</div>
            <div class="linedata" v-if="item.zx_avg_status == 0">{{ item.zx_avg || '-' }}{{ item.unit }}</div>
            <div class="linedata warningcolor" v-else>
              {{ item.zx_avg || '-' }}{{ item.unit
              }}<i
                class="icon iconfont"
                :class="item.zx_avg_status == 1 ? 'icon-down' : 'icon-up-copy'"
                style="font-size: 12px"
              />
            </div>
          </div>
          <div class="itemline">
            <div class="linetit">最大</div>
            <div class="linedata" v-if="item.zx_max_status == 0">{{ item.zx_max || '-' }}{{ item.unit }}</div>
            <div class="linedata warningcolor" v-else>
              {{ item.zx_max || '-' }}{{ item.unit
              }}<i
                class="icon iconfont"
                :class="item.zx_max_status == 1 ? 'icon-down' : 'icon-up-copy'"
                style="font-size: 12px"
              />
            </div>
          </div>
          <div class="itemline">
            <div class="linetit">最小</div>
            <div class="linedata" v-if="item.zx_min_status == 0">{{ item.zx_min || '-' }}{{ item.unit }}</div>
            <div class="linedata warningcolor" v-else>
              {{ item.zx_min || '-' }}{{ item.unit
              }}<i
                class="icon iconfont"
                :class="item.zx_min_status == 1 ? 'icon-down' : 'icon-up-copy'"
                style="font-size: 12px"
              />
            </div>
          </div>
        </div>
      </div>
      <nullData v-else></nullData>
    </div>

    <!-- 日曲图 -->
    <div class="radiusdiv">
      <div class="daybrokeline">
        <div class="brokeleft">
          <div class="broketext">日曲图</div>
          <DatePicker
            v-model="curveTime"
            type="date"
            placeholder="请选择时间"
            :editable="false"
            format="yyyy-MM-dd"
            style="width: 130px"
            @on-change="getDayCurveTable"
          />
          <div class="optionlist">
            <RadioGroup v-model="equiId" @on-change="changeOption">
              <template v-for="item in equipmentList">
                <Radio :label="item.code_id" :key="item.code_id"
                  ><span :class="equiId == item.code_id ? 'rideospan' : ''">{{ item.cn_name }}</span></Radio
                >
              </template>
            </RadioGroup>
          </div>
        </div>
      </div>
      <div class="daybrokentable">
        <Spin v-if="dataInfoLoading" fix>
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load" />
          <div>加载中...</div>
        </Spin>
        <div ref="dayBrokenTable" v-if="dayNullData"></div>
        <nullData v-else></nullData>
      </div>
    </div>

    <!-- 历史在线 -->
    <div class="radiusdiv">
      <div class="historybox">
        <div class="historyleft">
          <div class="historytext">历史在线</div>
          <!-- <historyTimeChange
            :yearTime="yearName"
            :createTime="createTime"
            @sendChangeTime="changeYear"
          ></historyTimeChange> -->
        </div>
        <div class="historyright">
          <DatePicker
            placement="top-end"
            v-model="tableTime"
            type="datetimerange"
            placeholder="请选择时间"
            :editable="false"
            format="yyyy-MM-dd"
            style="width: 200px; margin-right: 10px"
            @on-change="searchTime"
          />
          <Button type="primary" ghost @click="exportFile"><i class="iconfont icon-daochu"></i>导出</Button>
        </div>
      </div>
      <!-- 历史表格 -->
      <div class="tablebox">
        <Table :columns="columns11" :data="data10" stripe :loading="tbLoading"></Table>
        <Page
          style="padding: 10px 0"
          show-total
          :current.sync="page"
          :page-size-opts="[20, 50, 100, 200]"
          :page-size="row"
          :total="total"
          show-sizer
          @on-change="onNextPage"
          @on-page-size-change="onPageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import { parseTime } from '@/utils/date.js';
import { mathEleHeight, exportExcel, overMonth } from '@/utils/common';
import nullData from '@/components/nullData.vue';
// 历史年选择
import historyTimeChange from '@/components/historyTimeChange.vue';
export default {
  components: {
    nullData,
    historyTimeChange,
  },
  props: {
    gkSiteId: {
      type: [String, Number],
      default: '',
    },
    // 公司创建时间
    companyTime: {
      type: String,
      default: '',
    },
    // 公司id
    company_id: {
      type: [String, Number],
      default: '',
    },
  },
  watch: {
    async gkSiteId() {
      // 获取当年年份
      this.yearName = Number(parseTime(new Date(), '{y}'));
      this.createTime = this.companyTime;
      this.compnayId = this.company_id;
      this.timeFlag = true;
      this.equiId = 0;
      await this.getYYNowInfo();
      await this.getEquimentData();
      await this.getYYHistoryInfo(1);
    },
  },
  data() {
    return {
      timeFlag: true, // true 可以启动定时器
      createTime: '', // 公司创建时间
      compnayId: '', // 当前选中的公司id
      yearName: '', // 历史在线时间
      dayCacheList: [],
      dayNullData: true,
      dayTimeIndex: 0,
      dayTableTime: '',
      minuteH: '',
      dataInfoLoading: false, // 信息加载动画
      curveTime: new Date(), // 曲线图时间
      unit: '', // 单位
      tbLoading: false, //
      equipmentList: [], // 设备列表
      btnFlag: '',
      page: 1,
      row: 20,
      total: 0,
      tableTime: '',
      equiId: '', // 被选中选择id
      echart: '',
      realTimeList: [], // 实时
      onlyTime: '',
      columns11: [], // 表头
      data10: [], // 表数据
    };
  },
  mounted() {
    this.getDivHeight();
  },
  methods: {
    changeYear(n) {
      this.yearName = n;

      this.getYYHistoryInfo(1);
    },
    changeOption() {
      for (let i = 0; i < this.equipmentList.length; i++) {
        const element = this.equipmentList[i];
        if (element.code_id == this.equiId) {
          this.monitName = element.cnName;
          this.dayTimeIndex = i;
          break;
        }
      }
      this.timeFlag = false;
      this.getDayCurveTable();
    },
    getDivHeight() {
      this.minuteH = mathEleHeight(this.$refs.hoursdata, 20);
    },
    /**
     * 得到在线 【实时数据】
     */
    getYYNowInfo() {
      const apis = 'zxHourData/getRealTimeZxHourDataList';
      let params = {
        gkSite_id: this.gkSiteId,
      };

      this.dataInfoLoading = true; // 开启加载动画
      this.realTimeList = [];
      this.onlyTime = '';
      // 开启请求
      this.$http.get(this.ApiUrl + apis, { params }).then(
        res => {
          // 当list里有数据时
          const list = res.data.extend.ZxHourData;
          if (res.data.extend.news === 0 && list.length > 0) {
            // // 赋值标图数据

            this.realTimeList = list;

            this.onlyTime = parseTime(list[0].receive_time); // 监测时间
          }
          this.dataInfoLoading = false; // 关闭加载动画
        },
        res => {
          this.dataInfoLoading = false; // 关闭加载动画
        },
      );
    },
    // 获取设备数据
    getEquimentData() {
      let url = this.ApiUrl + 'zxHourData/getZxHourCode';
      let params = {
        gkSite_id: this.gkSiteId,
      };
      this.$http
        .get(url, { params })
        .then(res => {
          if (res.data.code == 200) {
            this.equipmentList = res.data.extend.ZxHourData;
            this.dayTimeIndex = 0;
            this.dayCacheList = [];
            if (this.equipmentList.length > 0) {
              this.equiId = this.equipmentList[0].code_id;
              this.getDayCurveTable();
            } else {
              this.dayNullData = false;
            }
          } else {
            this.dayNullData = false;
            this.$Message.warning(res.data.extend.message);
          }
        })
        .catch(res => {
          this.dayNullData = false;
        });
    },
    // 日曲线图
    getDayCurveTable() {
      if (!this.gkSiteId) {
        this.$Message.warning('请选择排口');
        return;
      }
      if (!this.equiId) {
        this.$Message.warning('请选择检测项');
        return;
      }
      let url = this.ApiUrl + 'zxHourData/getZxHourCodeTime';
      let realTime = parseTime(this.curveTime || new Date(), '{y}-{m}-{d}');
      let params = {
        gkSite_id: this.gkSiteId,
        code_id: this.equiId || '',
        time: realTime,
      };
      this.dataInfoLoading = true;
      this.$http
        .get(url, { params })
        .then(res => {
          this.dataInfoLoading = false;
          if (res.data.code == 200) {
            let list = res.data.extend.ZxHourData;
            let totalList = []; // 累计
            let avgList = []; // 平均
            let maxList = []; // 最大
            let minList = []; // 最小
            let dataTime = []; // 时间
            let unit = ''; // 单位
            for (let i = 0; i < list.length; i++) {
              const ele = list[i];
              if (ele.zx_total === 0 || ele.zx_total) {
                totalList.push(ele.zx_total * 1);
              }

              avgList.push(ele.zx_avg * 1 || 0);
              maxList.push(ele.zx_max * 1 || 0);
              minList.push(ele.zx_min * 1 || 0);
              dataTime.push(ele.receive_time ? parseTime(ele.receive_time, '{h}:{i}') : '00:00');
              if (i == 0) {
                unit = ele.unit || '';
              }
            }

            if (this.equipmentList.length > 0) {
              this.dayTimeTable();
            }

            // 判断是否要暂停定时器
            if (!this.timeFlag) {
              if (this.dayTableTime) {
                clearInterval(this.dayTableTime);
              }
            }
            // 保存数据
            this.dayCacheList[this.dayTimeIndex] = {
              totalList,
              avgList,
              maxList,
              minList,
              dataTime,
              unit,
              realTime,
            };

            if (
              totalList.length == 0 &&
              dataTime.length == 0 &&
              avgList.length == 0 &&
              maxList.length == 0 &&
              minList.length == 0 &&
              minList.length == 0
            ) {
              this.dayNullData = false;
            } else {
              this.dayNullData = true;
              this.$nextTick(() => {
                this.initEcharts(totalList, avgList, maxList, minList, dataTime, unit, realTime);
              });
            }
          }
        })
        .catch(res => {
          this.dataInfoLoading = false;
        });
    },
    // 定时切换定时器
    dayTimeTable() {
      if (this.dayTableTime) {
        clearInterval(this.dayTableTime);
      }
      this.dayTableTime = setInterval(() => {
        if (this.equipmentList.length - 1 > this.dayTimeIndex) {
          this.dayTimeIndex++;
        } else {
          this.dayTimeIndex = 0;
        }
        let info = this.equipmentList[this.dayTimeIndex];
        this.equiId = info.code_id || '';
        this.monitName = info.cnName || '';
        let datainfo = this.dayCacheList[this.dayTimeIndex];
        if (datainfo && datainfo.totalList) {
          if (
            datainfo.totalList.length == 0 &&
            datainfo.dataTime.length == 0 &&
            datainfo.avgList.length == 0 &&
            datainfo.maxList.length == 0 &&
            datainfo.minList.length == 0 &&
            datainfo.minList.length == 0
          ) {
            this.dayNullData = false;
          } else {
            this.dayNullData = true;
            this.$nextTick(() => {
              this.initEcharts(
                datainfo.totalList,
                datainfo.avgList,
                datainfo.maxList,
                datainfo.minList,
                datainfo.dataTime,
                datainfo.unit,
                datainfo.realTime,
              );
            });
          }
        } else {
          this.getDayCurveTable();
        }
      }, 5000);
    },
    // 分页
    onNextPage(e) {
      this.getYYHistoryInfo(e);
    },
    onPageSize(e) {
      this.row = e;
      this.getYYHistoryInfo(1);
    },
    // 时间选择
    searchTime() {},

    // 初始化图表
    initEcharts(totalList, avgList, maxList, minList, dataTime, unit, realTime) {
      let data = ['平均', '最大', '最小'];
      let series = [
        {
          name: '平均',
          type: 'line',
          smooth: true,
          data: avgList,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 3, //设置线条粗细
              },
            },
          },
        },
        {
          name: '最大',
          type: 'line',
          smooth: true,
          data: maxList,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 3, //设置线条粗细
              },
            },
          },
        },
        {
          name: '最小',
          type: 'line',
          smooth: true,
          data: minList,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 3, //设置线条粗细
              },
            },
          },
        },
      ];
      if (totalList.length) {
        data.unshift('累计');
        series.unshift({
          name: '累计',
          type: 'line',
          itemStyle: {
            normal: {
              lineStyle: {
                width: 3, //设置线条粗细
              },
            },
          },
          smooth: true,
          data: totalList,
        });
      }

      this.echart = echarts.init(this.$refs.dayBrokenTable);
      this.echart.clear();
      this.echart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderColor: '#FFFFFF',
          extraCssText: 'box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);',
          padding: 10,
          textStyle: {
            // 提示框浮层的文本样式。
            color: '#233C52',
            fontSize: 12,
          },
          formatter: res => {
            let opt = '';
            for (let i = 0; i < res.length; i++) {
              const element = res[i];
              if (i == 0) {
                opt += `<div>${realTime} ${element.axisValue}</div>`;
              }
              opt += `<div><span>${element.seriesName}</span>：<span style="color:${element.color}" >${element.value} ${unit}</span></div>`;
            }
            return opt;
          },
        },
        legend: {
          data: data,
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 10,
          top: '1px',
          formatter: ['{a|{name}}'].join('\n'),
          textStyle: {
            height: 8,
            rich: {
              a: {
                verticalAlign: 'bottom',
              },
            },
          },
        },
        color: ['#FACD4F', '#39AEA9', '#52D7FF', '#9979F2'],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dataTime,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#aaaaaa',
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#aaaaaa',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#E1E2E7'],
              width: 1,
              type: 'deshad',
            },
          },
        },
        series: series,
      });
    },
    // 导出文件
    exportFile() {
      if (this.tableTime.length == 0) {
        this.$Message.warning('请选择时间段');
        return;
      }

      if (!this.gkSiteId) {
        this.$Message.warning('请选择排口');
        return;
      }

      // 不要超过四个月
      if (!overMonth(this.tableTime[0], this.tableTime[1], 4)) {
        this.$Message.warning('选择的日期请不要超过4个月');
        return;
      }

      exportExcel(this.compnayId, this.gkSiteId, this.tableTime[0], this.tableTime[1], this, 1);
    },
    /**
     * 得到油烟 【历史数据】  渲染表格
     */
    getYYHistoryInfo(page) {
      const apis = 'zxHourData/findHistoryData';
      let params = {
        gkSite_id: this.gkSiteId,
        pageNo: page,
        pageSize: this.row,
        // time: this.yearName + '',
      };
      this.tbLoading = true; // 开启加载动画
      this.data10 = [];
      this.columns11 = [];
      this.total = 0;
      // 开启请求
      this.$http
        .get(this.ApiUrl + apis, { params })
        .then(res => {
          this.data10 = [];
          this.columns11 = [];
          this.page = page;
          if (res.data.extend.news === 0) {
            // 表中数据

            this.columns11.push({
              type: 'index',
              title: '序号',
              align: 'center',
              minWidth: 90,
              indexMethod: row => {
                return row._index + 1 + this.page * this.row - this.row;
              },
            });
            var titleList = res.data.extend.ZxHourData;
            for (var i = 0; i < titleList.length; i++) {
              let list = titleList[i];
              this.data10.push({});
              if (list.data && list.data.length > 0) {
                for (let h = 0; h < list.data.length; h++) {
                  let infoList = this.data10[i];
                  let info = list.data[h];
                  if (i == 0) {
                    this.columns11.push({
                      title: info.cn_name || '-',
                      align: 'center',
                      children: [
                        {
                          title: '累计',
                          align: 'center',
                          key: 'zx_total_' + h,
                          minWidth: 130,
                        },
                        {
                          title: '平均',
                          align: 'center',
                          key: 'zx_avg_' + h,
                          minWidth: 130,
                        },
                        {
                          title: '最大',
                          align: 'center',
                          key: 'zx_max_' + h,
                          minWidth: 130,
                        },
                        {
                          title: '最小',
                          align: 'center',
                          key: 'zx_min_' + h,
                          minWidth: 130,
                        },
                      ],
                    });
                  }

                  infoList['zx_total_' + h] = (info.zx_total ? info.zx_total * 1 : 0) + (info.unit || '');
                  infoList['zx_avg_' + h] = (info.zx_avg ? info.zx_avg * 1 : 0) + (info.unit || '');
                  infoList['zx_max_' + h] = (info.zx_max ? info.zx_max * 1 : 0) + (info.unit || '');
                  infoList['zx_min_' + h] = (info.zx_min ? info.zx_min * 1 : 0) + (info.unit || '');
                  if (h == list.data.length - 1) {
                    infoList['time'] = info.receive_time;
                  }
                }
              }
            }
            this.columns11.push({
              title: '监测时间',
              align: 'center',
              key: 'time',
              minWidth: 180,
              fixed: 'right',
            });
            this.total = res.data.extend.total; // 设置总页数
          } else {
            this.total = 0;
          }
          this.tbLoading = false; // 关闭加载动画
        })
        .catch(() => {
          this.tbLoading = false; // 关闭加载动画
          this.total = 0;
          this.data10 = [];
          this.columns11 = [];
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// 滚动条宽高
.timedatapage::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
// 滚动条背景颜色
.timedatapage::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 5px;
}
// 滚动条颜色
.timedatapage::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
// 鼠标移动到滚动条上颜色
.timedatapage::-webkit-scrollbar-thumb:hover {
  background: rgb(122, 121, 121);
}
.timedatapage {
  overflow-y: auto;
  .realtopbox {
    border-radius: 0 0 8px 8px;
    background: #fff;
    padding: 0 15px;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
  .realtop {
    display: flex;
    align-items: center;
    .realtext {
      display: flex;
      position: relative;
      padding-left: 14px;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      margin-right: 30px;
    }
    .realtext::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 4px;
      height: 14px;
      background-color: #0062ff;
      transform: translateY(-50%);
    }
    .timesline {
      display: flex;
      padding: 6px 8px;
      background-color: #0062ff;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      border-radius: 4px;
      .iconclock {
        font-size: 15px;
        color: #fff;
        margin-right: 5px;
      }
    }
  }
  .realbottom {
    margin-top: 15px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 15px 25px;
    .itemoptbox {
      box-shadow: 0 0 4px #d1d0d0;
      background: #f5f5f5;
      padding-top: 15px;
      display: flex;
      flex-direction: column;
      padding-bottom: 10px;
      border-radius: 8px;
      .itemtitle {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        .devicon {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          margin-right: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          > i {
            color: #fff;
          }
        }

        .iconcolor1 {
          background-color: #19be6b;
        }

        .devtext {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
      }
      .itemline {
        display: flex;
        justify-content: center;
        .linetit {
          margin-right: 10px;
          font-size: 14px;
          font-weight: 400;
          line-height: 28px;
          color: #5f788e;
        }
        .linedata {
          font-size: 14px;
          font-weight: bold;
          line-height: 28px;
        }
      }
    }
  }
  .daybrokeline {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
    .brokeleft {
      display: flex;
      align-items: center;
      .broketext {
        font-size: 16px;
        font-weight: bold;
        line-height: 56px;
        color: #233c52;
        position: relative;
        padding-left: 9px;
        margin-right: 36px;
        white-space: nowrap;
      }
      .broketext::before {
        position: absolute;
        content: '';
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #0062ff;
      }
      .optionlist {
        margin-left: 20px;
      }
    }
  }
  .daybrokentable {
    height: 250px;
    width: 100%;
    position: inherit;
    > div {
      width: 100%;
      height: 100%;
    }
  }
  .historybox {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .historyleft {
      display: flex;
      align-items: center;
      .historytext {
        padding-left: 9px;
        position: relative;
        font-size: 16px;
        font-weight: bold;
        line-height: 56px;
        color: #233c52;
        margin-right: 20px;
      }
      .historytext::before {
        content: '';
        width: 4px;
        height: 16px;
        background: #0062ff;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
    .historyright {
      i {
        margin-right: 5px;
        font-size: 14px;
      }
    }
  }
  .normalcolor {
    color: #19be6b;
  }
  .warningcolor {
    color: #e72d14;
  }
  .linehr {
    width: 100%;
    border-bottom: 1px solid #dcdee2;
    margin-top: 20px;
  }
  .radiusdiv {
    background: #fff;
    padding: 0 15px;
    border-radius: 8px;
  }
  .rideospan {
    color: #2d8cf0;
  }
}
</style>
